<template>
  <div class="columns">
    <div class="column is-12-mobile is-12-desktop is-12-widescreen">
      <div class="level">
        <div class="level-left">
          <div class="title is-marginless is-paddingless">Businesses
            <span v-if="is_loading || fetching_data"
                  :class="{'is-loading': (is_loading || fetching_data)}"
                  class="button is-white has-text-right preloader"></span>
          </div>
        </div>
      </div>
      <div v-if="!is_loading" class="columns">
        <div class="columns">
          <div class="column is-desktop is-12-mobile is-full-tablet is-paddingless margin-top-4 is-full-widescreen">
            <span class="is-size-7 has-text-grey is-full-mobile">Business name or alias: &nbsp;</span>
          </div>
        </div>
        <div class="column is-paddingless margin-right-20 is-2-desktop is-3-tablet">
          <search :addMarginLeft=false
                  :keywordProp.sync="keyword_string"
                  class="is-paddingless is-marginless"
                  desktopCss="is-11-tablet is-11-desktop"
                  placeholder="Search"
                  v-on:search="search($event)"></search>
        </div>

        <div class="columns">
          <div class="column is-desktop is-12-mobile is-full-tablet is-paddingless margin-top-4 is-full-widescreen">
            <span
              class="is-size-7 has-text-grey is-full-mobile has-text-weight-bold font-size-14">&nbsp; OR &nbsp;</span>
          </div>
        </div>

        <div class="columns">
          <div class="column is-desktop is-12-mobile is-full-tablet is-paddingless margin-top-4 is-full-widescreen">
            <span class="is-size-7 has-text-grey is-full-mobile">Business ID: &nbsp;</span>
          </div>
        </div>
        <div class="column is-paddingless margin-right-20 is-2-desktop is-3-tablet">
          <search :addMarginLeft=false
                  :keywordProp.sync="bizId_string"
                  class="is-paddingless is-marginless"
                  desktopCss="is-12-tablet is-11-desktop"
                  placeholder="Search"
                  urlProp="bizId" v-on:search="searchByBizId($event)"></search>
        </div>

        <div v-if="!isTablet" class="columns">
          <div class="column is-narrow is-paddingless">
            <button class="button is-button-grey-outline is-pulled-right createBizModalCss"
                    @click="createBusinessModal()">CREATE BUSINESS
            </button>
          </div>
        </div>
      </div>
      <div v-if="!is_loading" class="columns">
        <div class="columns">
          <div class="column is-narrow pad-left-0">
            <span class="is-size-7 has-text-grey is-pulled-left">Package:&nbsp;</span>
          </div>
          <div class="column is-narrow is-paddingless">
            <multiple-selection-drop-down
              ref="packages"
              :checkedItems="checkedItems"
              :items.sync="packages"
              :placeHolder="packagePlaceholder"
              btnMinWidth="button-width-200px"
              class="is-paddingless is-marginless"
              dropdownName="packages"
              @multiple-dropdown-changed="setPackage($event)"></multiple-selection-drop-down>
          </div>
        </div>

        <div v-if="isTablet" class="columns">
          <div class="column is-narrow is-paddingless">
            <button class="button is-button-grey-outline is-pulled-right createBizModalCss"
                    @click="createBusinessModal()">CREATE BUSINESS
            </button>
          </div>
        </div>
      </div>

      <p v-if="!is_loading" v-resultsCount="[total_records, all_records]" class="margin-top-30"></p>
      <div v-if="!is_loading" class="level">
        <table class="table is-size-7-touch is-marginless is-fullwidth">
          <thead>
          <tr>
            <td class="is-narrow-mobile is-size-7-mobile is-size-7-desktop has-text-weight-bold has-text-grey">ID</td>
            <td class="pad70-desktop is-size-7-mobile is-size-7-desktop has-text-weight-bold has-text-grey">Business
            </td>
            <td class="is-narrow-mobile is-size-7-mobile is-size-7-desktop has-text-weight-bold has-text-grey">Status
            </td>
            <td class="is-narrow-mobile pad35-desktop is-desktop is-size-7-desktop has-text-weight-bold has-text-grey">
              Industry
            </td>
            <td class="is-narrow-mobile pad35-desktop is-desktop is-size-7-desktop has-text-weight-bold has-text-grey">
              Total reviews
            </td>
            <td class="is-narrow-mobile review-title is-size-7-desktop has-text-weight-bold has-text-grey">Active
              package
            </td>
            <td class="is-narrow-mobile review-title is-size-7-desktop has-text-weight-bold has-text-grey">End date</td>
          </tr>
          </thead>
          <tbody>
          <tr v-if="(is_loading && items.length === 0) || (!fetching_data && items.length === 0)">
            <td class="is-narrow pad70-desktop is-size-7-mobile is-size-7-desktop has-text-weight-bold has-text-grey"
                colspan="8">
              <p class="has-text-centered is-padded-20">No results found</p>
            </td>
          </tr>
          <tr v-for="(business, index) in items" v-if="items.length > 0" class="margin-bottom-20 goto-business"
              v-on:click="gotoBusiness(business)">
            <td class="is-narrow-mobile is-size-7-touch">{{ business.id }}</td>
            <td class="is-size-7-mobile is-size-7-touch has-text-weight-bold">{{ asText(business.org_name, 80) }}</td>
            <td class="is-narrow-mobile is-size-7-touch">{{ business.org_status | capitalize }}</td>
            <td class="is-narrow-mobile is-desktop">{{ business.industry_name }}</td>
            <td class="is-narrow-mobile is-desktop">{{ business.reviewCount }}</td>
            <td class="is-narrow-mobile is-desktop">{{ business.subscription_name }}
              {{ (business.subscription_name === 'Lite') ? '(Annual)' : '' }}
            </td>
            <td class="is-narrow-mobile is-desktop">{{ business.end_date }}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="level">
        <paginator :bizId_string="bizId_string" :dataSet="dataSet" :keyword_string="keyword_string"
                   @changed="getBusinessListings"></paginator>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable indent,no-new,no-undef,no-unused-expressions, no-useless-escape */
import Search from './../../components/Search.vue'
import MultipleSelectionDropDown from './../../components/MultipleSelectionDropDown'
import axios from 'axios'
import Paginator from './../../components/Paginator.vue'
import misc from '../../mixins/misc.js'
import qs from 'qs'

export default {
  metaInfo: {
    title: 'Business Portal | Hellopeter - Businesses'
  },
  mounted () {
    this.$gtm.trackEvent({
      event: 'pageLoad',
      virtualPageUrl: this.$router.currentRoute.path,
      virtualPageTitle: 'Businesses'
    })
  },
  components: { Search, Paginator, MultipleSelectionDropDown },
  mixins: [misc],
  data () {
    return {
      package_filter: '',
      is_loading: true,
      fetching_data: false,
      keyword_search: undefined,
      keyword_string: undefined,
      bizId_search: undefined,
      bizId_string: undefined,
      items: [],
      dataSet: {},
      page: undefined,
      total_records: 0,
      checkedItems: [],
      packagePlaceholder: 'All packages',
      selectedIndustry: 'Select Industry',
      packages: [
        {
          name: 'Free',
          value: 'Free'
        },
        {
          name: 'G1',
          value: 'G1'
        },
        {
          name: 'G2',
          value: 'G2'
        },
        {
          name: 'G3',
          value: 'G3'
        },
        {
          name: 'G4',
          value: 'G4'
        },
        {
          name: 'P1',
          value: 'P1'
        },
        {
          name: 'P2',
          value: 'P2'
        },
        {
          name: 'P3',
          value: 'P3'
        },
        {
          name: 'P4',
          value: 'P4'
        },
        {
          name: 'No package',
          value: 'no'
        }
      ],
      all_records: -1
    }
  },
  computed: {
    isTablet () {
      return this.screenWidth >= 768 && this.screenWidth <= 1022
    }
  },
  created () {
    setTimeout(() => {
      this.showFilterValues()
    }, 1000)
  },
  methods: {
    showFilterValues () {
      if (this.$route.query.keyword) {
        this.keyword_search = qs.stringify({ keyword: this.$route.query.keyword })
        this.keyword_string = this.$route.query.keyword
      }
      if (this.$route.query.bizId) {
        this.bizId_search = qs.stringify({ bizId: this.$route.query.bizId })
        this.bizId_string = this.$route.query.bizId
      }
      if (this.$route.query.package) {
        this.package_filter = this.$route.query.package
        let filterArr = this.package_filter.split(`&package`)
        let filteredArr = filterArr.filter(function (val) {
          return val !== ''
        })
        if (filteredArr.length > 1) {
          this.packagePlaceholder = 'Multiple selections'
        } else if (filteredArr.length === 1) {
          let packagePlaceholderStr = this.packages.filter((item) => {
            let filteredElement = filteredArr[0].substring(filteredArr[0].indexOf('=') + 1)
            if (filteredElement.includes('Lite') && filteredElement.includes('Monthly')) {
              filteredElement = 'Lite (Monthly)'
            }
            if (item.value.substring(item.value.indexOf('=') + 1) === filteredElement) {
              return item
            }
          })
          this.packagePlaceholder = packagePlaceholderStr.length > 0 ? packagePlaceholderStr[0].name : 'All packages'
        }
        filteredArr.forEach((value) => {
          if (value.includes('Lite') && value.includes('Monthly')) {
            this.checkedItems.push('Lite (Monthly)')
          } else {
            this.checkedItems.push(value.substring(value.indexOf('=') + 1))
          }
        })
      }
      this.getBusinessListings(null)
    },
    resetFilter () {
      this.package_filter = ''
      this.keyword_string = ''
      this.keyword_search = ''
      this.bizId_search = ''
      this.bizId_string = ''
      window.events.$emit('reset-filters')
      this.$router.push('/businesses')
      location.reload()
      this.getBusinessListings(1)
    },
    /**
     * Goes to business page for the chosen business
     * @param {object} business to open details view for an org
     * @returns {void}
     */
    gotoBusiness (business) {
      let filters = JSON.stringify({
        keyword: this.keyword_string,
        bizId: this.bizId_string,
        package: this.package_filter,
        page: this.page
      })
      localStorage.setItem('bizFilterList', filters)
      this.$router.push(`/business/${business.business_slug}/reviews`)
    },
    /** Sets package(s) to filter by
     * @param {object} event package(s) selected
     * @returns {void}
     */
    setPackage (event) {
      if (event.value.length > 0) {
        this.package_filter = '&' + qs.stringify({ package: event.value })
      } else {
        this.package_filter = ''
      }
      this.getBusinessListings(1)
    },
    /**
     * Search keyword/term to search for
     * @param {string} search search term/keyword
     * @returns {void}
     */
    search (search) {
      this.bizId_search = ''
      this.bizId_string = ''

      if (typeof search === 'string') {
        this.keyword_search = qs.stringify({ keyword: search })
        this.keyword_string = search
        this.getBusinessListings(1)
      } else {
        this.keyword_search = ''
        this.keyword_string = ''
        this.getBusinessListings(1)
      }
    },
    /**
     * Search biz ID to search for
     * @param {string} search search biz ID
     * @returns {void}
     */
    searchByBizId (search) {
      this.keyword_search = ''
      this.keyword_string = ''

      if (typeof search === 'string') {
        this.bizId_search = qs.stringify({ bizId: search })
        this.bizId_string = search
        this.getBusinessListings(1)
      } else {
        this.bizId_search = ''
        this.bizId_string = ''
        this.getBusinessListings(1)
      }
    },
    /**
     * Make request to api to get business listings
     * @returns {number | null}
     * @param {number} page page number to paginate to
     */
    getBusinessListings (page) {
      this.page = page || 1
      this.fetching_data = true
      axios.get(this.url(page, this.keyword_search, this.bizId_search))
        .then((response) => {
          this.refresh(response)
          this.is_loading = false
          this.fetching_data = false
        })
        .catch(() => {
          flash('You are not authorized to view this resource.', 'is-danger')
          this.is_loading = false
          this.fetching_data = false
        })
    },
    /**
     * Compute URI to make call to api with.
     * @param {string} page starting page to request
     * @param {string} keyword search keyword
     * @param {string} bizId search biz ID
     * @return {string}
     */
    url (page, keyword, bizId) {
      let query = location.search.match(/page=(\d+)/)
      if (!page) {
        page = query ? query[1] : 1
      }
      if (keyword !== undefined && this.keyword_string && this.keyword_string !== 0) {
        page += `&${keyword}`
      }
      if (bizId !== undefined && this.bizId_string && this.bizId_string !== 0) {
        page += `&${bizId}`
      }
      if (this.package_filter !== '') {
        page += `${this.package_filter}`
      }
      return `/businesses?page=${page}`
    },

    /**
     * create modal for new business
     * @return {null}
     */
    createBusinessModal () {
      let options = {
        'title': 'Create Business',
        'addNewBusinessByAdmin': true,
        'btn_action_title': 'CREATE',
        'cleanBizModalData': true,
        'show_btns': true
      }
      modal(options)
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) {
        return value
      }

      return value.charAt(0) + value.slice(1).toLowerCase()
    }
  }
}
</script>

<style scoped>
.table td, .table th {
  border: none;
}

.table > tbody > tr {
  background-color: #f5f5f5 !important;
  margin-bottom: 10px;
}

.table > tbody > td {
  margin-bottom: 20px;
}

tr.goto-business {
  cursor: pointer;
}

.biz_list {
  text-decoration: none;
}

.createBizModalCss {
  position: absolute;
  right: 32px;
}
</style>



// WEBPACK FOOTER //
// src/pages/admin/BusinessListing.vue